import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { IoPerson, IoPricetag, IoHome, IoLogOut } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { LogOut, reset } from "../features/authSlice";

const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const logout = () => {
    dispatch(LogOut());
    dispatch(reset());
    navigate("/");
  };

  return (
    <div>
      <aside className="menu pl-2 has-shadow">
        <p className="menu-label">General</p>
        <ul className="menu-list">
          <li>
            <NavLink to={"/dashboard"}>
              <IoHome /> Dashboard
            </NavLink>
          </li>
          <li>
            <NavLink to={"/pacientes"}>
              <IoPricetag /> Pacientes
            </NavLink>
          </li>
        </ul>
        {user && (user.role === "admin" || user.role === "doctor") &&  (
          <div>
            <p className="menu-label">Doctor</p>
            <ul className="menu-list">
              <li>
                <NavLink to={"/historias"}>
                  <IoPerson /> Historia Clinica
                </NavLink>
              </li>
            </ul>
          </div>
        )}
        {user && user.role === "admin" && (
          <div>
            <p className="menu-label">Admin</p>
            <ul className="menu-list">
              <li>
                <NavLink to={"/users"}>
                  <IoPerson /> Usuarios
                </NavLink>
              </li>
            </ul>
          </div>
        )}

        <p className="menu-label">Configuraciones</p>
        <ul className="menu-list">
          <li>
            <button onClick={logout} className="button is-white">
              <IoLogOut /> Desconectarse
            </button>
          </li>
        </ul>
      </aside>
    </div>
  );
};

export default Sidebar;